var React = require('react');

function MinusBlue (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.166992","y":"0.333984","width":"10.6667","height":"1.33333","rx":"0.666667","fill":"#3A66E5"}));
}

MinusBlue.defaultProps = {"width":"11","height":"2","viewBox":"0 0 11 2","fill":"none"};

module.exports = MinusBlue;

MinusBlue.default = MinusBlue;
